import React, { useState, useRef, useEffect, useContext } from 'react';
import { Button } from '../../../../common/Button';
import { CreateBusinessLogo, GetMerchantBusinessLogo, UpdateMerchantBusinessLogo } from '../../../../../pages/Settings/settingsAPI';
import { useAppSelector } from '../../../../../app/hooks';
import Loader from '../../../../common/Loader';
import { NetworkErrorAlertContext } from '../../../../../context/NetworkErrorAlert';
import { Initials, Paragraph, Wrapper, Image, UploadOverlay } from './styles';
import { ReactComponent as CameraIcon } from "../../../../../assets/icons/Camera.svg";

const LogoInputComponent = () => {
  const [logoUrl, setLogoUrl] = useState<string | null>(null);
  const [uploading, setUploading] = useState<boolean>(false);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [logoId, setLogoId] = useState(null)
  const { businessId } = useAppSelector((state) => state.users);
  const { business } = useAppSelector((state) => state.settings);
const {  name: businessName } = business;
  const { onShowAlert: onShowErrorAlert } = useContext(
    NetworkErrorAlertContext
  );

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const selectedFile = event.target.files[0];
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;

      if (!['image/jpeg', 'image/png'].includes(fileType)) {
        console.error("Only JPEG and PNG files are allowed.");
        return;
      }

      if (fileSize > 5 * 1024 * 1024) {
        console.error("File size must be less than 5MB.");
        return;
      }

      if (logoUrl) {
        UpdateBusinessLogo(selectedFile);
      } else {
        CreateNewBusinessLogo(selectedFile);
      }
    }
  };

  const extractInitials = (name) => {
    if (!name) return '';

    const words = name.split(' ');

    const initials = words.map(word => word.charAt(0).toUpperCase()).join('');

    return initials;
  };

  const initials = extractInitials(businessName);
  

  const generateInitials = () => {
    return initials;
  };

  const renderInitials = () => {
    const initials = generateInitials();
    return <Initials>{initials}</Initials>;
  };

  const CreateNewBusinessLogo = async (logo: File) => {
    const data = {
      businessId: businessId,
      customizationPage: "EMAIL",
    };
    setUploading(true);
    try {
      const response = await CreateBusinessLogo(data, logo);
      if (response?.businessLogo) {
        setLogoUrl(response.businessLogo);
      }
      await fetchBusinessLogo()
    } catch (error) {
        onShowErrorAlert("error", error?.response?.data?.message)
    } finally {
      setUploading(false);
    }
  };

  const UpdateBusinessLogo = async (logo: File) => {
    const data = {
      businessId: businessId,
      customizationPage: "EMAIL",
      id: logoId
    };
    setUploading(true);
    try {
      const response = await UpdateMerchantBusinessLogo(data, logo);
      if (response?.businessLogo) {
        setLogoUrl(response.businessLogo);
      }
      await fetchBusinessLogo()
    } catch (error) {
        onShowErrorAlert("error", error?.response?.data?.message)
    } finally {
      setUploading(false);
    }
  };

  const fetchBusinessLogo = async () => {
    try {
      const logoResponse = await GetMerchantBusinessLogo(businessId);      
      if (logoResponse && logoResponse.data && logoResponse.data.businessLogo) {
        setLogoUrl(logoResponse.data.businessLogo);
        setLogoId(logoResponse.data?.id)
      }
    } catch (error) {
      console.error('Error fetching business logo:', error);
    }
  };


    useEffect(() => {
    
    fetchBusinessLogo();
  }, []);
  


  return (
    <>
      <Wrapper>
        <Loader isLoading={uploading}/>
        {logoUrl ? (
          <Image src={logoUrl} alt="Logo" className="logo-image" />
        ) : (
          renderInitials()
        )}
        <input
          id="logoInput"
          type="file"
          accept=".png, .jpg, .jpeg"
          onChange={handleFileChange}
          style={{ display: 'none' }}
          ref={fileInputRef}
        />
        <UploadOverlay onClick={() => fileInputRef.current?.click()}>
          <div><CameraIcon/> {uploading ? "Uploading..." : "Upload photo"}</div>
        </UploadOverlay>
      </Wrapper>
      <Paragraph>Suggested dimensions: 1516 x 416 px
      </Paragraph>
      <Paragraph>Your business logo will be included on all transaction receipts issued to your customers.</Paragraph>

    </>
  );
};

export default LogoInputComponent;
